import { notification } from 'antd';
import React, { useEffect } from 'react';

import { verifyUhi } from '../api/login';
import { track } from '../tracking';
import { captureError } from './captureError';
import { onSuccess } from './Login';
import { GO_TO_LOGIN } from '../routes/paths';

const UhiLogin = (): JSX.Element => {
    const urlParams = new URLSearchParams(window.location.search);
    const state = urlParams.get('state') || '';
    const code = urlParams.get('code') || '';
    useEffect(() => {
        verifyUhi(state, code)
            .then((res) => {
                if (res.success) {
                    onSuccess(res.data?.profile?.oid);
                    track('UHI_LOGIN_SUCCESS');
                } else {
                    notification.error({
                        message: 'Incorrect credentials, login failed',
                        duration: 5,
                    });
                    setTimeout(() => {
                        window.location.replace(GO_TO_LOGIN);
                    }, 3000);
                    track('UHI_LOGIN_ERROR');
                }
            })
            .catch((error) => {
                captureError(error);
                notification.error({
                    message: error.message,
                    duration: 5,
                });
                setTimeout(() => {
                    window.location.replace(GO_TO_LOGIN);
                }, 3000);
                track('UHI_LOGIN_ERROR');
            });
    }, []);

    return (
        <div className="flex flex-col items-center justify-center w-screen h-screen space-y-64">
            <div className="pulse">
                <svg width="16px" height="12px">
                    <polyline id="back" points="1 6 4 6 6 11 10 1 12 6 15 6"></polyline>
                    <polyline id="front" points="1 6 4 6 6 11 10 1 12 6 15 6"></polyline>
                </svg>
            </div>
            <p className="text-24 text-neutral-black">Login with OHSN</p>
        </div>
    );
};

export default UhiLogin;
